// src/pages/Integrations/components/SettingsCard.tsx
import { css, SerializedStyles } from '@emotion/react';
import { Paper, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

const cardCss = css`
  background: #ffffff;
  border-left: 4px solid var(--mui-palette-primary-main, #6a45d3);
  border-radius: 8px;
  padding: 1rem;
  box-shadow:
    0 1px 2px rgba(16, 37, 62, 0.04),
    0 4px 12px rgba(16, 37, 62, 0.04);
`;

interface SettingsCardProps {
  /** Optional heading rendered as <h6>. */
  title?: ReactNode;
  /** Card body. */
  children: ReactNode;
  /** Additional emotion css to merge onto the card. */
  cardCssOverride?: SerializedStyles;
}

export function SettingsCard({ title, children, cardCssOverride }: SettingsCardProps) {
  return (
    <Paper elevation={0} css={[cardCss, cardCssOverride]}>
      <Stack gap='1rem'>
        {title && <Typography variant='h6'>{title}</Typography>}
        {children}
      </Stack>
    </Paper>
  );
}
